import { clearFormProgress, formProgressSync } from "../utils/formProgress";
import { handleSubmitBtnState } from "../utils/helpers";
import { getTimePickerValue } from "../utils/timepicker";
import FileHandler from "../classes/FileHandler";
import { fetchWithCSRF } from "../utils/xhrConfig";

const form = document.querySelector("form");
const formSyncId = "post_arrival_services_form";
const filesPicker = form.querySelector(".files-picker");
const fileContainer = document.getElementById("file-container");
const submitBtn = form.querySelector(".submit-btn");

// CONVERT ALL SELECT ELEMENTS TO SELECT2 DROPDOWNS AND DISABLE SARCH
$("select").select2({
  minimumResultsForSearch: Infinity
});
// END

// FORM PROGRESS SYNC
formProgressSync(form, formSyncId);
// FORM PROGRESS SYNC  END

// INSTATIATE FILE HANDLER CLASS
const fileHandler = new FileHandler(filesPicker, fileContainer);
filesPicker.addEventListener("change", (e) => {
  fileHandler.handleFileSelect();
});

//   ADD EVENT LISTENER TO FORM
form.addEventListener("submit", async (e) => {
  e.preventDefault();

  const inputEls = form.querySelectorAll("input, select");
  const fd = new FormData();

  // FIELDS TO IGNORE
  const ignoreFields = [
    "postArrivalServicesTimePicker_hour",
    "postArrivalServicesTimePicker_minute",
    "postArrivalServicesTimePicker_period",
    "csrfmiddlewaretoken",
    "documents"
  ];

  // console.log({ inputEls });

  for (const el of inputEls) {
    const isRequiredField = el.getAttribute("data-required") !== null;

    // USE DISPLAY NAME WHERE IT DOESN'T MAKE SENSE TO USE THE
    // LABEL CONTENT ASSOCIATED WITH THE FIELD
    // console.log({ isRequiredField });
    if (!ignoreFields.includes(el.name) && isRequiredField) {
      if (!el.value) {
        // console.log({ elName: el.name });
        const fieldName =
          el.getAttribute("data-displayname") ||
          form.querySelector(`label[for="${el.name}"]`)?.textContent;
        el.focus();
        Swal.fire({
          icon: "warning",
          html: `<b>Attention!</b> <br /> <span class="font-medium">"${fieldName?.trim()}"</span> field cannot be empty`
        });
        return;
      }

      fd.append(el.name, el.value);
    }

    // CONFIRM USER CHOICE
    if (el.name === "interested_in_accomodation") {
      const accommodationTypeField = [...inputEls].find(
        (el) => el.name === "accomodation_type"
      );

      if (el.value === "NO" && accommodationTypeField.value) {
        accommodationTypeField.focus();
        Swal.fire({
          icon: "warning",
          html: `<b>Conflicting Choices Detected!</b> <br /> If you're not interested in our accommodation offer, please leave <span class="font-medium">"Type of accommodation"</span> field empty`
        });
        return;
      }

      if (el.value === "YES" && !accommodationTypeField.value) {
        accommodationTypeField.focus();
        Swal.fire({
          icon: "warning",
          html: `<b>Conflicting Choices Detected!</b> <br /> We're glad you've showed interest in our accommodation offer. However, <span class="font-medium">"Type of accommodation"</span> field cannot be empty when opting for our accommodation package`
        });
        return;
      }
    }
  }

  // VALIDATE DOCUMENTS FIELD
  const isDocumentsFieldValid = validateFilesInput();
  if (!isDocumentsFieldValid) return;

  // APPEND TIME OF ARRIVAL
  const { timeString } = getTimePickerValue("postArrivalServicesTimePicker");
  fd.append("time_of_arrival", timeString);
  // APPEND DOCUMENTS
  for (const file of filesPicker.files) fd.append("document", file);

  handleSubmitBtnState(submitBtn);
  // return;
  try {
    let res = await fetchWithCSRF("", {
      method: "POST",
      body: fd
    });
    res = await res.json();
    // console.log({ res });

    if (res.status === "success") {
      Swal.fire({
        icon: "success",
        html: `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br /> Congratulations! Your post-arrival services request has been received. Rest assured, as we'll take care of the rest!<br /> <b>We will reach out to you as soonest.</b></h5>`
      });

      fileHandler.clearFiles();

      clearFormProgress(form, formSyncId);
      handleSubmitBtnState(submitBtn, false);
    } else {
      console.log({ JsonResponseError: error });
      Swal.fire({
        icon: "error",
        html: `<h5 class='text-base mobile:text-sm'><b>Uncaught Error!</b> <br />Sorry! An error occured while processing your request</h5>`
      });
    }
  } catch (error) {
    handleSubmitBtnState(submitBtn, false);
    Swal.fire({
      icon: "error",
      html: `<h5 class='text-base mobile:text-sm'><b>Oops!</b> <br />Sorry! An error occured while processing your request</h5>`
    });
  }
});

// FUNCTIONS
function validateFilesInput() {
  if (!filesPicker.files.length) {
    filesPicker.focus();

    Swal.fire({
      icon: "warning",
      html: `<b>Attention!</b> <br /> <span class="font-medium">"Documents"</span> field cannot be empty`
    });
    return false;
  }
  return true;
}
